import { feature } from 'topojson-client'
import { geoAlbersUsa, geoPath } from 'd3-geo'
import statesTopo from 'us-atlas/states-10m.json'
import { US_STATE_BY_NAME } from './usStates'

/**
 * Geographic state outlines from us-atlas (US Census cartographic
 * boundaries in longitude/latitude). The Albers USA projection insets
 * Alaska and Hawaii and fits the states onto a 975×610 canvas. Territories
 * are dropped; DC stays. Each entry carries its SVG path, label centroid,
 * and the centroid nudges in LABEL_OFFSETS for the small north-eastern
 * states whose labels would otherwise sit on a neighbour.
 */
const LABEL_OFFSETS = {
  VT: [-6, 0],
  NH: [6, -2],
  MA: [10, -3],
  RI: [16, 5],
  CT: [12, 7],
  NJ: [11, 2],
  DE: [13, 4],
  MD: [8, 9],
  DC: [18, 11],
}

const pathFor = geoPath(geoAlbersUsa().scale(1280).translate([487.5, 305]))

export const US_MAP_VIEWBOX = '0 0 975 610'

export const US_STATE_PATHS = feature(statesTopo, statesTopo.objects.states).features.map(geo => {
    const state = US_STATE_BY_NAME[String(geo.properties.name || '').toLowerCase()]
    if (!state) return null
    const [cx, cy] = pathFor.centroid(geo)
    const [dx, dy] = LABEL_OFFSETS[state.code] || [0, 0]
    return { ...state, d: pathFor(geo), labelX: cx + dx, labelY: cy + dy, centroidX: cx, centroidY: cy }
  })
  .filter(Boolean)
